<template lang="pug">
#usersContent(:class="{allprjPriviUsers: from == 'allprjPrivi',inline: inline}" )
  .users( v-for="(user, index) in userList" :key="index" :title="user.name || user.userName" )
    el-checkbox(v-if="from==='allprjPrivi'",v-model="user.$selectAll",:true-label="1",:false-label="0",@change="singleCheck",style='margin-right:3px')
    el-image(:src="circleUrl(user)" v-if="!user.selectCode||user.selectCode==='User'")
      .userAvatar(slot="error") {{userName(user.selectName||user.name||user.userName)}}
    node-icon(:type="user.selectCode" v-else)
    .name {{ user.selectName || user.name||user.userName}}
    i.delete.el-icon-delete(:class="{'noClick':disabled}" v-if="!disabled" @click="deleteUser(user)")
</template>

<script>
import { gettouxAvatar } from "@/CommonDP/utils";
import NodeIcon from "./component/NodeIcon.vue";
export default {
  name: "UserItem",
  components: { NodeIcon },
  props: {
    userList: {
      type: Array,
      default: () => []
    },
    inline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    grup: {
      type: Object,
      default: () => {}
    },
    from: {
      type: String,
      default: () => ""
    }
  },
  data () {
    return {
      roleIcon: require("@/CommonDP/assets/doc/role.png")
    };
  },
  methods: {
    circleUrl(item) {
      const avatatDescribe = {
        "User": () => {
          return gettouxAvatar(item.userId);
        },
        "SystemRole": () => {
          return require("@/CommonDP/assets/doc/role.png");
        },
        "SpecRole": () => {
          return require("@/CommonDP/assets/doc/role.png");
        },
        "PrjRole": () => {
          return require("@/CommonDP/assets/doc/role.png");
        },
        "Label": () => {
          return require("@/CommonDP/assets/org/tag.png");
        },
        "Dept": () => {
          return require('@/CommonDP/assets/doc/folderChild.png');
        }
      };
      const selectCode = item.selectCode || "User";
      return avatatDescribe[selectCode] ? avatatDescribe[selectCode]() : "";
    },
    errorHandler() {
      return true;
    },
    deleteUser(user) {
      if (this.disabled) { return; }
      this.$confirm(`确认${this.deleteToolTip(user)}:${user.name || user.selectName || user.userName}?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box"
      }).then(async () => {
        this.$emit("deleteUser", user);
      }).catch(() => {
        // this.$message.info("已取消");
      });
    },
    deleteToolTip(user) {
      const tipDescribe = {
        "User": () => { return "删除人员"; },
        "SystemRole": () => { return "删除系统角色"; },
        "SpecRole": () => { return "删除专业角色"; },
        "PrjRole": () => { return "删除项目角色"; },
        "Label": () => { return "删除标签"; },
        "Dept": () => { return "删除部门"; }
      };
      return tipDescribe[user.selectCode] ? tipDescribe[user.selectCode]() : "删除";
    },
    userName(val) {
      return val?.charAt?.(0) || "";
    },
    singleCheck() {
      this.$forceUpdate();
      this.userList.forEach((e, index) => {
        this.grup.userList[index].$selectAll = e.$selectAll;
      });
      this.$emit('singleCheck', this.grup);
    }
  }

};
</script>

<style lang="scss" scoped>
#usersContent{
  width: calc(100% - 10px);
  max-height: 170px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  .users{
    padding: 5px 10px;
    height: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 5px;
    .el-image{
      width: 20px;
      height: 20px;
      border-radius: 5px;
      object-fit: contain;
    }
    /deep/.userAvatar{
      line-height: 20px;
      font-size: 12px;
      border-radius: 5px;
      text-align: center;
      background-color: var(--theme-color);
      color: #fff;
    }
    .name{
      margin-left: 5px;
      font-size: 12px;
      line-height: 28px;
    }
    i{
      margin-left: 5px;
      font-size: 14px;
      line-height: 28px;
      color: rgb(214, 10, 10);
      cursor: pointer;
    }
    .noClick{
      cursor: not-allowed;
    }
  }
  .users:hover{
    background-color: #ebeef5;
  }
}
.inline{
  flex-direction: row !important;
  flex-wrap: wrap;
}
.allprjPriviUsers{
  flex-direction: row !important;
  flex-wrap: wrap;
}
</style>
